export default "__VITE_ASSET__6008e4fc__"